/**
 * Tools Dashboard — Time Saved (ROI) tour
 */

export const getDashboardRoiTourSteps = (isAdmin = false) => {
  const steps = [
    {
      id: 'welcome',
      title: 'Time Saved (ROI)',
      description:
        'See how much time Apps and Gems are saving — program-wide if you are an admin, or just your own usage.',
      position: 'center',
    },
  ];

  if (isAdmin) {
    steps.push({
      id: 'tabs',
      title: 'ROI and Usage tabs',
      description:
        'Switch between Time Saved (ROI) and Usage analytics. This tour covers the ROI view.',
      element: '[data-tour="dashboard-tabs"]',
      position: 'bottom',
      spotlight: true,
    });
  }

  steps.push(
    {
      id: 'hero',
      title: isAdmin ? 'Program-wide savings' : 'Your Time Saved',
      description: isAdmin
        ? 'Headline hours reclaimed across the catalog for the last 90 days, plus active users and tool coverage.'
        : 'Your personal hours saved in the last 30 days and lifetime — based on sessions and configured estimates.',
      element: '[data-tour="roi-hero"]',
      position: 'bottom',
      spotlight: true,
    },
    {
      id: 'tools-board',
      title: isAdmin ? 'Tools Leaderboard' : 'Tools by time saved',
      description: isAdmin
        ? 'Rank tools by time saved or sessions. Search to focus the list — great for spotting high-impact Gems and Apps.'
        : 'Configured tools ranked by time saved. Search and sort to explore what matters most.',
      element: '[data-tour="roi-tools-leaderboard"]',
      position: 'top',
      spotlight: true,
    }
  );

  if (isAdmin) {
    steps.push({
      id: 'users-board',
      title: 'Users Leaderboard',
      description:
        'See who is saving the most time. Use search and sort to explore adoption across the org.',
      element: '[data-tour="roi-users-leaderboard"]',
      position: 'top',
      spotlight: true,
    });
  } else {
    steps.push({
      id: 'my-tools',
      title: 'Your top tools',
      description:
        'Your most-used tools by time saved. Report a session here if you want to refine estimates.',
      element: '[data-tour="roi-user-top-tools"]',
      position: 'top',
      spotlight: true,
    });
  }

  return steps;
};
